import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useQuery } from '@tanstack/react-query'
import { BaseParams } from 'types/utils'

export function useGetAttachment({
  id,
  params
}: BaseParams<{ offset: number; limit: number }>) {
  async function getAttachment() {
    try {
      if (!id) throw new Error('Attachment ID is required')
      const res = await apiClient.get<Blob>(
        `${SNA_PREFIX}messages/attachments/${id}`,
        {
          params,
          responseType: 'blob' // Ensure the response is treated as a file
        }
      )
      return res.data
    } catch (error) {
      throw new Error('Failed to fetch attachment', { cause: error })
    }
  }

  return useQuery({
    queryFn: getAttachment,
    queryKey: ['attachment', id],
    enabled: !!id // Prevent query from running when id is undefined
  })
}
